import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

/**
 * @link https://github.com/8x8/platform_sharedservices_sms_service/blob/develop/api/src/main/java/com/_8x8/shared/services/sms/vo/ThirdParty.java
 */
export const thirdPartyMap = {
  TWILIO: "TWILIO",
  INTELIQUENT: "INTELIQUENT",
  INTELIQUENT_TF: "INTELIQUENT_TF",
  TEST_MESSAGE: "TEST_MESSAGE",
  INTQ_REST: "INTQ_REST",
  INTQ_SMP: "INTQ_SMP",
  WAVECELL: "WAVECELL",
};

const schema = yup.object({
  channelId: yup.number().nullable(),
  // Used for manual phone number entry
  countryCode: yup.string().when("didId", {
    is: (didId) => !didId,
    then: (countrySchema) =>
      countrySchema.required(
        "Country code is required when manually entering a phone number"
      ),
    otherwise: (countrySchema) => countrySchema.nullable(),
  }),
  phoneNumber: yup
    .string()
    /** @see schemaFields.js */
    .unique()
    // @TODO: when selecting CPaaS, phoneNumber can be alphanumeric
    // .matches(E164_REGEX, {
    //   message: "Phone number must be in E.164 format",
    //   excludeEmptyString: true,
    // })
    .required(),
  status: yup.string(),
  scriptId: yup.string().nullable(),
  queueId: yup.string().nullable(),
  didId: yup
    .string()
    /** @see schemaFields.js */
    .unique()
    .nullable(),
  thirdParty: yup.string().oneOf(Object.values(thirdPartyMap)),
  // @TODO: enforce wavecell sub-account ID regex validation
  wavecellSubAccountId: yup.string().when("thirdParty", {
    is: (thidParty) => thidParty === thirdPartyMap.WAVECELL,
    then: (wavecellSchema) =>
      wavecellSchema.required(
        "Sub-Account ID is required for Wavecell SMS numbers"
      ),
    otherwise: (wavecellSchema) => wavecellSchema.nullable(),
  }),
  wavecellApiKey: yup.string().nullable(),
  subscriptionId: yup.string().nullable(),
});

addKeyToFieldsRecursively(schema);

export default schema;
